import type { AxiosResponse } from 'axios';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export interface ToggleLikeParams {
  userId: number;
  likeId: number;
  likeableId: number;
  type: string;
}

export type ToggleLike = (
  params: ToggleLikeParams,
) => Promise<AxiosResponse<any, any> | null>;

const toggleLike = ({
  userId,
  likeId,
  likeableId,
  type,
}: ToggleLikeParams): Promise<AxiosResponse<any, any> | null> => {
  if (likeId) {
    return axios.delete(Routes.user_like_path(type, likeId)).then(() => null);
  }

  return axios
    .post(Routes.user_likes_path(userId), {
      like: {
        likeable_id: likeableId,
        likeable_type: type,
      },
    })
    .then(({ data: { like } }) => like);
};

export default toggleLike;
